import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const EN2424Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "EN2424IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 4H22V19H2V4Z"
        fill="#F7FCFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 13.1667V14.4167H22V13.1667H2Z"
        fill="#E31D1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 15.4583V16.7083H22V15.4583H2Z"
        fill="#E31D1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 8.58325V9.83325H22V8.58325H2Z"
        fill="#E31D1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 17.75V19H22V17.75H2Z"
        fill="#E31D1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 10.875V12.125H22V10.875H2Z"
        fill="#E31D1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 4V5.25H22V4H2Z"
        fill="#E31D1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 6.29175V7.54175H22V6.29175H2Z"
        fill="#E31D1C"
      />
      <rect x="2" y="4" width="12.5" height="8.125" fill="#2E42A5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.07602 5.83663L2.62234 6.15468L2.77551 5.58868L2.37256 5.22998H2.89886L3.07538 4.76807L3.28236 5.22998H3.73102L3.3785 5.58868L3.51498 6.15468L3.07602 5.83663ZM5.57618 5.83669L5.1225 6.15475L5.27567 5.58874L4.87272 5.23004H5.39903L5.57554 4.76813L5.78253 5.23004H6.23119L5.87866 5.58874L6.01514 6.15475L5.57618 5.83669ZM7.6225 6.15475L8.07618 5.83669L8.51514 6.15475L8.37866 5.58874L8.73119 5.23004H8.28253L8.07554 4.76813L7.89903 5.23004H7.37272L7.77567 5.58874L7.6225 6.15475ZM10.5762 5.83669L10.1225 6.15475L10.2757 5.58874L9.87272 5.23004H10.399L10.5755 4.76813L10.7825 5.23004H11.2312L10.8787 5.58874L11.0151 6.15475L10.5762 5.83669ZM2.6225 8.65475L3.07618 8.33669L3.51514 8.65475L3.37866 8.08874L3.73119 7.73004H3.28253L3.07554 7.26813L2.89903 7.73004H2.37272L2.77567 8.08874L2.6225 8.65475ZM5.57618 8.33669L5.1225 8.65475L5.27567 8.08874L4.87272 7.73004H5.39903L5.57554 7.26813L5.78253 7.73004H6.23119L5.87866 8.08874L6.01514 8.65475L5.57618 8.33669ZM7.6225 8.65475L8.07618 8.33669L8.51514 8.65475L8.37866 8.08874L8.73119 7.73004H8.28253L8.07554 7.26813L7.89903 7.73004H7.37272L7.77567 8.08874L7.6225 8.65475ZM10.5762 8.33669L10.1225 8.65475L10.2757 8.08874L9.87272 7.73004H10.399L10.5755 7.26813L10.7825 7.73004H11.2312L10.8787 8.08874L11.0151 8.65475L10.5762 8.33669ZM2.6225 11.1547L3.07618 10.8367L3.51514 11.1547L3.37866 10.5887L3.73119 10.23H3.28253L3.07554 9.76813L2.89903 10.23H2.37272L2.77567 10.5887L2.6225 11.1547ZM5.57618 10.8367L5.1225 11.1547L5.27567 10.5887L4.87272 10.23H5.39903L5.57554 9.76813L5.78253 10.23H6.23119L5.87866 10.5887L6.01514 11.1547L5.57618 10.8367ZM7.6225 11.1547L8.07618 10.8367L8.51514 11.1547L8.37866 10.5887L8.73119 10.23H8.28253L8.07554 9.76813L7.89903 10.23H7.37272L7.77567 10.5887L7.6225 11.1547ZM10.5762 10.8367L10.1225 11.1547L10.2757 10.5887L9.87272 10.23H10.399L10.5755 9.76813L10.7825 10.23H11.2312L10.8787 10.5887L11.0151 11.1547L10.5762 10.8367ZM12.6225 6.15475L13.0762 5.83669L13.5151 6.15475L13.3787 5.58874L13.7312 5.23004H13.2825L13.0755 4.76813L12.899 5.23004H12.3727L12.7757 5.58874L12.6225 6.15475ZM13.0762 8.33669L12.6225 8.65475L12.7757 8.08874L12.3727 7.73004H12.899L13.0755 7.26813L13.2825 7.73004H13.7312L13.3787 8.08874L13.5151 8.65475L13.0762 8.33669ZM12.6225 11.1547L13.0762 10.8367L13.5151 11.1547L13.3787 10.5887L13.7312 10.23H13.2825L13.0755 9.76813L12.899 10.23H12.3727L12.7757 10.5887L12.6225 11.1547ZM4.32618 7.08669L3.8725 7.40475L4.02567 6.83874L3.62272 6.48004H4.14903L4.32554 6.01813L4.53253 6.48004H4.98119L4.62866 6.83874L4.76514 7.40475L4.32618 7.08669ZM6.3725 7.40475L6.82618 7.08669L7.26514 7.40475L7.12866 6.83874L7.48119 6.48004H7.03253L6.82554 6.01813L6.64903 6.48004H6.12272L6.52567 6.83874L6.3725 7.40475ZM9.32618 7.08669L8.8725 7.40475L9.02567 6.83874L8.62272 6.48004H9.14903L9.32554 6.01813L9.53253 6.48004H9.98119L9.62866 6.83874L9.76514 7.40475L9.32618 7.08669ZM3.8725 9.90475L4.32618 9.58669L4.76514 9.90475L4.62866 9.33874L4.98119 8.98004H4.53253L4.32554 8.51813L4.14903 8.98004H3.62272L4.02567 9.33874L3.8725 9.90475ZM6.82618 9.58669L6.3725 9.90475L6.52567 9.33874L6.12272 8.98004H6.64903L6.82554 8.51813L7.03253 8.98004H7.48119L7.12866 9.33874L7.26514 9.90475L6.82618 9.58669ZM8.8725 9.90475L9.32618 9.58669L9.76514 9.90475L9.62866 9.33874L9.98119 8.98004H9.53253L9.32554 8.51813L9.14903 8.98004H8.62272L9.02567 9.33874L8.8725 9.90475ZM11.8262 7.08669L11.3725 7.40475L11.5257 6.83874L11.1227 6.48004H11.649L11.8255 6.01813L12.0325 6.48004H12.4812L12.1287 6.83874L12.2651 7.40475L11.8262 7.08669ZM11.3725 9.90475L11.8262 9.58669L12.2651 9.90475L12.1287 9.33874L12.4812 8.98004H12.0325L11.8255 8.51813L11.649 8.98004H11.1227L11.5257 9.33874L11.3725 9.90475Z"
        fill="#F7FCFF"
      />
    </svg>
  );
};

export default EN2424Icon;
